const status = "production";
// const status = "development";
export const staffRequest = status === "development" ? "http://localhost:3005/" : "https://backend.cosmopolitan.edu.ng:7441/";
export const localRequest = status === "development" ? "http://localhost:3008/" : "https://backend.cosmopolitan.edu.ng:7442/";
export const appHost = status === "development" ? "http://localhost:3003/" :  window.location.origin;

export const UploadLink = status === "development" ? "https://doc.samtec.ng/index.php" : "https://doc.samtec.ng/index.php";
